import { useEffect, useState } from "react";
import { api } from "../lib/api";
import CreditHistory from "../components/CreditHistory";

export default function StoricoCrediti() {
  const [ent, setEnt] = useState(null);
  useEffect(() => { api.get("/entitlements").then((r) => setEnt(r.data)).catch(() => {}); }, []);
  const hasPlan = ent && (ent.plan === "sub" || ent.plan === "gift");
  return (
    <div className="max-w-3xl mx-auto px-4 lg:px-8 py-16 sm:py-20" data-testid="storico-crediti-page">
      <div className="mb-10">
        <p className="eyebrow">Il tuo account</p>
        <h1 className="font-display text-4xl text-amber-100 mt-3">Storico dei crediti</h1>
        <p className="text-purple-200/70 mt-2 text-sm">Tutti i movimenti dei tuoi crediti consultazione.</p>
      </div>
      {hasPlan && (
        <div className="mystic-card p-5 mb-8" data-testid="piano-consultazioni-oggi">
          <h2 className="font-cinzel text-xs tracking-[0.25em] uppercase text-amber-400/80 mb-2">Il tuo piano</h2>
          <p className="text-sm text-purple-100/85">
            Consultazioni di oggi: <span className="text-amber-200 font-medium">{ent.consults_used_today} usate su {ent.consults_limit}</span>
            {" · "}te ne {ent.consults_left_today === 1 ? "resta" : "restano"} <span className="text-amber-200 font-medium">{ent.consults_left_today}</span>
          </p>
          {ent.access_until && (
            <p className="text-xs text-purple-300/60 mt-1.5" data-testid="piano-scadenza">
              {ent.plan === "sub" ? "Abbonamento attivo" : "Accesso attivo"} fino al{" "}
              {new Date(ent.access_until).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}
            </p>
          )}
          <p className="text-xs text-purple-300/60 mt-2 leading-relaxed">
            Le consultazioni del piano si rinnovano ogni giorno e non consumano i crediti acquistati, che restano disponibili qui sotto.
          </p>
        </div>
      )}
      <CreditHistory alwaysOpen />
    </div>
  );
}
